module.exports = __webpack_public_path__ + "static/img/logo.1a7da9ae.png";